import React from 'react';
import Toggle from 'material-ui/Toggle';
import * as Colors from '../../utils/Color';
import { Field } from 'react-form';

const styles = {
    thumbOff: {
        backgroundColor: Colors.primary,
    },
    trackOff: {
        backgroundColor: Colors.primary50,
    },
    thumbSwitched: {
        backgroundColor: Colors.secondary,
    },
    trackSwitched: {
        backgroundColor: Colors.secondary50,
    }
};

const SwitchToggle = props => {

    if (props.notForm) {
        return (
            <Toggle
                onToggle={ props.onToggle }
                toggled={ props.toggled }
                className="switch-toggle"
                thumbStyle={styles.thumbOff}
                trackStyle={styles.trackOff}
                thumbSwitchedStyle={styles.thumbSwitched}
                trackSwitchedStyle={styles.trackSwitched}
                style={{width: '36px'}}
            />
        );
    }

    return (
        <Field field={ props.field }>
            { fieldApi => {
                const { setValue } = fieldApi;

                return (
                    <Toggle
                        onToggle={ (e, isInputChecked) => setValue(isInputChecked) }
                        defaultToggled={ props.toggled }
                        className="switch-toggle"
                        thumbStyle={styles.thumbOff}
                        trackStyle={styles.trackOff}
                        thumbSwitchedStyle={styles.thumbSwitched}
                        trackSwitchedStyle={styles.trackSwitched}
                        style={{width: '36px'}}
                    />
                );
            }}
        </Field>
    )
};

export default SwitchToggle;


// WEBPACK FOOTER //
// ./src/components/UI/SwitchToggle.js